import { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';

interface SaveWallTemplateDialogProps {
  open: boolean;
  error: string | null;
  isSaving: boolean;
  onClose: () => void;
  onSave: (input: { name: string; description: string }) => void;
}

export function SaveWallTemplateDialog({
  open,
  error,
  isSaving,
  onClose,
  onSave,
}: SaveWallTemplateDialogProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (!open) {
      return;
    }

    setName('');
    setDescription('');
  }, [open]);

  const sanitizedName = name.trim();
  const canSave = sanitizedName.length > 0 && !isSaving;

  const save = () => {
    if (!canSave) {
      return;
    }

    onSave({
      name: sanitizedName,
      description: description.trim(),
    });
  };

  return (
    <Dialog open={open} onClose={() => !isSaving && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>Save as Template</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <TextField
            label="Template name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            disabled={isSaving}
            fullWidth
          />
          <TextField
            label="Description"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            disabled={isSaving}
            fullWidth
            multiline
            minRows={4}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={save} disabled={!canSave}>
          {isSaving ? 'Saving...' : 'Save Template'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
